import {useState} from "react";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";

export const useModalPanelAdm = () => {

    const [visibleModalRemoveCache, setVisibleModalRemoveCache] = useState<boolean>(false);
    const [visibleModalAllowSubscriptionUpgrade, setVisibleModalAllowSubscriptionUpgrade] = useState<boolean>(false);
    const [visibleModalExternallyPay, setVisibleModalExternallyPay] = useState<{
        visible: boolean,
        payment: PaymentEntity | null
    }>({
        visible: false,
        payment: null,
    });
    const [visibleModalRefund, setVisibleModalRefund] = useState<{
        visible: boolean,
        payment: PaymentEntity | null
    }>({
        visible: false,
        payment: null,
    });

    return {
        visibleModalRemoveCache, setVisibleModalRemoveCache,
        visibleModalExternallyPay, setVisibleModalExternallyPay,
        visibleModalRefund, setVisibleModalRefund,
        visibleModalAllowSubscriptionUpgrade, setVisibleModalAllowSubscriptionUpgrade
    }
}
